// marking-warn-dialog.service.ts
import { Injectable, ViewContainerRef } from '@angular/core';
import { DialogCloseResult, DialogRef, DialogResult, DialogService, DialogSettings } from '@progress/kendo-angular-dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { MarkingWarnComponent } from '../components/marking-warn/marking-warn.component';
import { MarkActionType } from '../interface/get-all-notifications-response';

@Injectable({
  providedIn: 'root',
})
export class MarkingWarnService {
  constructor(private dialogService: DialogService) { }
  public dontShowAgainWarSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public dontShowAgainWarn$: Observable<boolean> = this.dontShowAgainWarSubject.asObservable();

  public open(action: MarkActionType, vcr?: ViewContainerRef): Observable<DialogCloseResult | DialogResult> {
    const dialogOptions: DialogSettings = {
      content: MarkingWarnComponent,
      width: 530,
      minWidth: 250,
      cssClass: 'marking-warn-dialog',
    };
    if (vcr) {
      dialogOptions.appendTo = vcr;
    }

    const dialog: DialogRef = this.dialogService.open(dialogOptions);
    const content: MarkingWarnComponent = dialog.content.instance as MarkingWarnComponent;
    content.action = action;

    return dialog.result as Observable<DialogCloseResult | DialogResult>;
  }

  setDontShowWarnAgain(value: boolean): void {
    this.dontShowAgainWarSubject.next(value);
  }
}
